import React from 'react';
import { FiDownload, FiTerminal } from 'react-icons/fi';
import { FaWindows, FaApple, FaLinux } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

const downloadFile = async (url: string, filename: string) => {
  const token = localStorage.getItem('token');
  const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  const blob = await response.blob();
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  link.click();
};

const DownloadCard = ({ icon: Icon, title, steps, agentUrl, agentFile, installUrl, installFile, t }: any) => (
  <div className="bg-slate-800 rounded-2xl p-6">
    <div className="flex items-center gap-3 mb-6">
      <div className="bg-blue-600 p-3 rounded-xl"><Icon className="text-white text-2xl" /></div>
      <h3 className="text-white text-xl font-semibold">{title}</h3>
    </div>
    <div className="space-y-3 mb-6">
      {steps.map((step: string, i: number) => (
        <div key={i} className="flex items-start gap-3">
          <span className="bg-blue-600 text-white text-xs w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">{i + 1}</span>
          <p className="text-slate-300 text-sm">{step}</p>
        </div>
      ))}
    </div>
    <div className="flex gap-3">
      <button onClick={() => downloadFile(agentUrl, agentFile)}
        className="flex-1 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg transition-colors text-sm font-semibold">
        <FiDownload />{t('downloadAgent')}
      </button>
      <button onClick={() => downloadFile(installUrl, installFile)}
        className="flex-1 flex items-center justify-center gap-2 bg-slate-700 hover:bg-slate-600 text-white py-3 rounded-lg transition-colors text-sm font-semibold">
        <FiTerminal />{t('installScript')}
      </button>
    </div>
  </div>
);

const Download = () => {
  const { t } = useLanguage();
  return (
    <div>
      <h1 className="text-white text-3xl font-bold mb-2">{t('downloadAgents')}</h1>
      <p className="text-slate-400 mb-8">{t('downloadDesc')}</p>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <DownloadCard icon={FaWindows} title="Windows" t={t}
          steps={['Enable BitLocker on drive C:', 'Download agent and install script', 'Run as Administrator', 'Execute: BrickManagerSetup-v3.3.exe']}
          agentUrl="/api/download/windows/setup" agentFile="BrickManagerSetup-v3.3.exe"
          installUrl="/api/download/windows/install" installFile="install-windows.ps1" />
        <DownloadCard icon={FaApple} title="macOS" t={t}
          steps={['Enable FileVault in System Preferences', 'Download agent and install script', 'Open Terminal', 'Execute: sudo bash install-macos.sh']}
          agentUrl="/api/download/macos" agentFile="brickmanager-agent.py"
          installUrl="/api/download/macos/install" installFile="install-macos.sh" />
        <DownloadCard icon={FaLinux} title="Linux" t={t}
          steps={['Install Ubuntu with LUKS encryption', 'Download agent and install script', 'Open Terminal', 'Execute: sudo bash install-linux.sh']}
          agentUrl="/api/download/linux" agentFile="brickmanager-agent.py"
          installUrl="/api/download/linux/install" installFile="install-linux.sh" />
      </div>
      <div className="mt-8 bg-slate-800 rounded-2xl p-6">
        <h2 className="text-white text-xl font-semibold mb-4">{t('orgToken')}</h2>
        <p className="text-slate-400 text-sm mb-3">{t('orgTokenDesc')}</p>
        <div className="bg-slate-700 rounded-xl p-4">
          <p className="text-green-400 font-mono text-sm">e0a4b608-68e3-4a75-99c0-03d31df36169</p>
        </div>
      </div>
    </div>
  );
};

export default Download;
